import { useHistory } from "react-router-dom";
import { UUID } from "./UUID";
import { urlParams } from "../Utility/QueryString";

export const RingbaCheckUUID = () => {
  const full_url = window.location.href;
  const params = Object.fromEntries(urlParams.entries());
  const query = new URLSearchParams(window.location.search);
  const queryString = (window.location.href.split('?')[1] || '').trim();

  const history = useHistory();
  const { fetchUuid } = UUID();
  const split_name = query.get("splitName");
  const dob = query.get("dob");
  const isCheck = () => {
    var flag = false;
    var localFlag = false;
    if (!params.hasOwnProperty("uuid") || (params.hasOwnProperty("uuid") && !urlParams.get("uuid")) || (params.hasOwnProperty("uuid") && urlParams.get("uuid") === '""')) {
      flag = true;
    }
    if (!localStorage.getItem('uuid')) {
      localFlag = true;
    }
    if (flag && localFlag) {
      history.push("/404");
      return false;
    } else {
      const uuid = fetchUuid();
      const field = 'uuid';
      if (queryString != null) {
        if (queryString.indexOf('&' + field + '=') != -1 ||
          queryString.indexOf('?' + field + '=') != -1 ||
          queryString.indexOf(field + '=') != -1) {
          window.history.pushState({}, '', '?' + queryString);
        } else {
          window.history.pushState({}, '', '?' + queryString + '&uuid=' + uuid);
        }
      } else {
        window.history.pushState({}, '', '?uuid=' + uuid);
      }
    }
  }
  return { isCheck }
}